import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Does the patient have a medical condition that prevents him or her from consuming normal table foods or softened, mashed, pureed or blenderized foods?</p>
				<div className="toggle">
					<div className={this.props.data.MedicalCondition == 'Y' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('MedicalCondition', 'Y') }}>Yes</div>
					<div className={this.props.data.MedicalCondition == 'N' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('MedicalCondition', 'N') }}>No</div>
				</div>

				<br />

				<p>If mode of administration will be oral, have alternatives, such as dietary changes, instant breakfast drinks, rice cereal, etc., been tried but were unsuccessful?</p>
				<div className="toggle">
					<div className={this.props.data.AlternateUnsuccess == 'Y' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('AlternateUnsuccess', 'Y') }}>Yes</div>
					<div className={this.props.data.AlternateUnsuccess == 'N' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('AlternateUnsuccess', 'N') }}>No</div>
				</div>
				<br />

				<p>Has the adult patient had a significant unintentional weight loss greater than 5% over the past two months, or has the pediatric patient had no weight or height gain in the past six months?</p>
				<div className="toggle">
					<div className={this.props.data.WeightLoss == 'Y' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('WeightLoss', 'Y') }}>Yes</div>
					<div className={this.props.data.WeightLoss == 'N' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('WeightLoss', 'N') }}>No</div>
				</div>

				<div className="button" onClick={() => this.props.navigate('R24')}>Continue</div>
			</div>
		);

	}
}